import { useMutation } from "react-query";
import ExternalBondRecordsService, {
  ExternalBondRecordRequest,
} from "../api/services/ExternalBondRecordsService";

const SUBMIT_FAILED_MESSAGE =
  "We could not submit your application. Please check your answers and try again.";

/**
 * A refused order comes back as `errors.order` and a rejected payload as
 * `errors.<field>`, so both read out of the same place.
 */
const getSubmitErrorMessage = (error: any): string => {
  const data = error?.response?.data;

  const messages: string[] = Object.values(data?.errors ?? {}).flat() as string[];

  return messages.join(" ") || data?.message || SUBMIT_FAILED_MESSAGE;
};

export const useExternalBondRecord = () => {
  const { mutateAsync, isLoading, isError, error } = useMutation(
    (payload: ExternalBondRecordRequest) =>
      ExternalBondRecordsService.submitOrder(payload)
  );

  return {
    submitExternalBondRecord: mutateAsync,
    isExternalSubmitLoading: isLoading,
    externalSubmitErrorMessage: isError
      ? getSubmitErrorMessage(error)
      : undefined,
  };
};
